/* eslint-disable max-len */

export default {
  lang: 'Anglais',
  homeScreen: {
    title: "La Capitale Mondiale des Parcs d'Attractions", // Spécifique au produit
    stayConnected: 'Restez Connecté',
    comingSoon: 'Bientôt Disponible',
    messages: 'Messages',
  },
  notification: {
    newAndNow: 'Nouveautés du moment!',
    alert: 'Alerte',
    message: 'Message',
    contest: 'Concours',
    badge: 'Nouveau Badge',
    'content-update': 'Mise à jour de contenu',
    events: 'Événements',
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Voyons si nous pouvons trouver un profil existant pour vous dans notre système.',
      homeTitleSub:
        "Saisissez l'adresse électronique que vous utilisez habituellement pour vous connecter aux programmes de formation.",
      noAccount:
        "Aucun compte n'a été trouvé ({email}), veuillez essayer avec un autre email ou créer un compte maintenant.",
      continueButton: 'Continuer',
      success:
        "La mise à jour de votre compte a été effectuée avec succès ! Vous serez bientôt redirigé vers la page d'accueil.",
      successNewAccount:
        'Pour compléter votre inscription, vous recevrez un courriel de confirmation pour vérifier votre compte.',
      loginButton: 'Connexion',
      matchFound:
        'Nous avons trouvé une correspondance, veuillez saisir votre mot de passe pour continuer.',
      magicLink:
        "Connectez-vous à l'aide d'un lien figurant dans votre courrier électronique :",
      magicLinkButton: 'Demande de lien magique',
      magicLinkTitle:
        'Un lien direct vous est envoyé par e-mail pour vous permettre de vous inscrire instantanément.',
      otherEmailButton: 'Soumettre',
      title:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      titleIndustry:
        "Veuillez prendre le temps de compléter toutes les informations ci-dessous, car elles permettront d'établir votre profil personnel et vos coordonnées.",
      register: 'Créer un compte',
      agent: 'Conseiller en voyages',
      visitor: "Visiteur de l'industrie",
      step1: "Étape 1 : Type d'utilisateur",
      step2: 'Étape 2 : Créer un compte',
      step3: 'Étape 3 : Créer votre profil',
      marketingOptIn:
        "Êtes-vous sûr de ne pas vouloir rester en contact avec l'équipe commerciale de ce programme ?",
      optIn: 'Oui, je suis intéressé',
      optOut: 'Pas intéressé',
      step2Sub1: 'Parlez-nous de vous',
      step2Sub2: 'Parlez-nous de votre entreprise',
      privacyHead: 'LES PRÉFÉRENCES EN MATIÈRE DE COMMUNICATION',
      privacySub:
        "Cochez les cases ci-dessous pour vous assurer de recevoir les communications importantes de l'équipe commerciale du fournisseur (mises à jour et annonces de produits, récompenses, incitations, FAM, etc.) et les initiatives de TravPRO Mobile en matière de réseautage et d'aide à la vente pour les professionnels du voyage.",
      privacy:
        "Nous protégeons votre vie privée et ne vendons pas, n'utilisons pas à mauvais escient et ne trahissons pas votre confiance.",
      store:
        "Téléchargez facilement ce programme dans votre magasin d'applications :",
      powered: 'ALIMENTÉ PAR',
      toastMessage: {
        forgotSuccess:
          'Nous vous avons envoyé par e-mail le lien de réinitialisation de votre mot de passe ! Vous serez redirigé vers la page de connexion dans 10 secondes.',
        emailNotExisting:
          "L'adresse électronique que vous avez saisie n'existe pas.",
        magicLinkMessage:
          'Veuillez patienter, nous sommes en train de vous inscrire.',
        magicLinkError:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkError1:
          "Nous n'avons pas trouvé de jeton valide, veuillez vous connecter ou demander un nouveau lien magique. Si le problème persiste, veuillez nous contacter à l'adresse suivante : info@travpromobile.com.",
        magicLinkError2:
          "Nous n'avons pas trouvé votre compte dans notre base de données, veuillez vous connecter manuellement. Vous serez redirigé dans 10 secondes.",
        magicLinkSuccess:
          "Consultez votre courrier électronique à l'adresse {email}. Il contient un lien magique qui vous permettra de vous connecter.",
        magicLinkErrorWait:
          'Veuillez attendre 5 minutes entre les demandes de liens magiques.',
        emailNotFoundError:
          "L'adresse électronique que vous avez saisie ne figure pas dans nos dossiers. Veuillez vérifier les fautes d'orthographe ou créer un compte.",
      },
      errors: {
        zipCodeNotFound: 'Code postal non trouvé, réessayez',
        zipCodeOnlyNumbers: 'ZipCode ne peut contenir que des chiffres',
        password: 'Veuillez saisir un mot de passe',
        passwordNotMatching: 'Les mots de passe saisis ne correspondent pas',
        passwordTooShort:
          'Le mot de passe doit comporter au moins 8 caractères',
        emailExists:
          "Cette adresse électronique existe déjà ou n'est pas valide. Veuillez essayer avec une autre adresse électronique ou vous connecter à votre compte.",
        fillInAllFields: 'Veuillez remplir tous les champs obligatoires',
        fillInEmail: 'Veuillez indiquer votre adresse électronique.',
        emailNotExisting:
          "L'adresse électronique que vous avez saisie n'existe pas.",
      },
      fields: {
        forgotSubCopy:
          'Vous avez oublié votre mot de passe et souhaitez le modifier ? ',
        forgotSubCopy2:
          'Vous voulez éviter le mot de passe ? Nous vous enverrons un e-mail contenant un lien magique qui vous permettra de vous connecter automatiquement au programme.',
        city: 'Ville',
        companyName: "Nom de l'entreprise",
        role: 'Votre rôle',
        description:
          "Laquelle décrit le mieux l'activité de votre entreprise ?",
        country: 'Pays',
        password: 'Mot de passe',
        passwordRegister: 'Choisissez un mot de passe (8 caractères minimum)',
        passwordConfirm: 'Confirmer le mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom de famille',
        agency: "Nom de l'agence",
        title: 'Votre rôle (Sélectionnez un rôle)',
        company: "Nom de l'entreprise",
        select: 'Sélectionnez une option ci-dessous',
        state: 'État',
        province: 'Province/Région/État',
        zipCode: 'Code postal',
        postalCode: 'Code postal',
        affiliate:
          'Quel est le groupe auquel vous êtes PRINCIPALEMENT affilié ?',
        hostAgency: "Votre agence d'accueil ?",
        executive: 'Cadre',
        management: 'Gestion',
        marketing: 'Marketing',
        sales: 'Vente',
        coordinator: 'Coordinateur',
        opt: "Restez en contact avec l'équipe commerciale de ce programme et recevez des mises à jou",
        optMarketing:
          'Restez en contact avec TravPRO en ce qui concerne les programmes et événements similaires.',
        retail: "Façade d'un magasin de détail",
        home: 'Agent à domicile',
        independent: 'Entrepreneur indépendant',
        host: "Agence d'accueil",
        call: "Centre d'appel ou agence en ligne",
        other: 'Autres',
        describes:
          "Qu'est-ce qui décrit le mieux votre activité et celle de votre agence ?",
      },
    },
    title:
      "Formation pour les Professionnels du Voyage et Programme d'Activation des Ventes", // Spécifique au produit (Texte TravPRO ou ChannelPRO)
    welcome: {
      headerTop: 'Bienvenue à',
      headerBottom: 'Orlando Travel Academy', // Spécifique au produit
    },
    sellingPoints: {
      // Tous les points de vente peuvent être spécifiques au produit
      0: "Gagnez 2 crédits CEU de l'Institut du Voyage",
      1: 'Cinq (5) Chapitres Fondamentaux pour Obtenir un Diplôme',
      2: 'Répertoire des Partenaires et Présentations pour les Consommateurs',
      3: "Support Marketing Prêt à l'Emploi",
      4: 'Ressources de Vente Intégrées à Fort Impact',
      5: 'Conseils et Promotions exclusifs',
      6: 'Actualités et Mises à Jour en Temps Opportun',
    },
    emailPrompt:
      'Veuillez entrer votre adresse e-mail et votre mot de passe pour confirmer que vous êtes un professionnel du voyage.', // Spécifique au produit (Texte TravPRO ou ChannelPRO)
    tAndC: {
      agree: 'En continuant, vous acceptez notre ',
      privacyPolicy: 'politique de confidentialité',
      and: ' et ',
      termsConditions: 'conditions générales',
    },
    fields: {
      agency: 'Agence',
      email: 'E-mail',
      password: 'Mot de passe',
      passwordConfirm: 'Confirmez votre mot de passe *',
      firstName: 'Prénom *',
      lastName: 'Nom de famille *',
      city: 'Ville *',
      agencyName: "Nom de l'Agence *",
      stateProvince: 'État / Province *',
      required: 'Requis',
      invalidEmail: 'Adresse e-mail invalide',
      opt: "Restez en Contact ! Oui, je souhaite recevoir les communications de l'Académie du Voyage d'Orlando qui me tiendront informé des actualités, des événements, des incitations, des FAM's et plus encore !",
      complete: 'Étape 2 : Complétez votre profil',
      tell: 'Parlez-nous de vous',
      title: 'Titre Professionnel *',
      host: "Nom de l'Agence Hôte",
      country: 'Pays / Région',
      select: 'Veuillez sélectionner une option ci-dessous',
      header2: 'Quel(s) segment(s) vendez-vous principalement ?',
      step2: 'Décrivez Votre Entreprise',
      leisure: 'Loisirs',
      corporate: 'Entreprises',
      group: 'Groupes',
      affiliate: 'Quelle est Votre Principale Affiliation ?',
      forgot:
        'Vous avez oublié votre mot de passe ? Cliquez sur le bouton ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.',
    },
    forgot: 'Réinitialiser le mot de passe',
    noAgent: {
      noAgentButton: 'Je ne suis pas un conseiller',
      title: "Merci pour votre intérêt pour l'Académie du Voyage d'Orlando.", // Spécifique au produit
      messageWeb:
        'Le contenu de ce site est exclusivement destiné aux professionnels du voyage. \n Pour en savoir plus sur Orlando, veuillez visiter : ', // Spécifique au produit
      messageMobile:
        "Certain contenu de cette application est exclusivement réservé aux professionnels du voyage, mais n'hésitez pas à parcourir un aperçu de ce que cette application a à offrir en appuyant sur 'Continuer'.", // Spécifique au produit
      continue: 'Continuer',
      visitWebsite: 'Visitez le site Web',
    },
    newUser: 'Nouvel Utilisateur',
    register: "S'inscrire",
    registered: 'Cette adresse e-mail est déjà enregistrée',
    forgot: 'Mot de passe oublié',
    header:
      'Veuillez prendre un moment pour remplir toutes les informations ci-dessous, car cela alimentera votre profil et vos coordonnées de contact.',
    step1:
      'Étape 1 : Saisissez votre adresse e-mail et choisissez un mot de passe.',
  },
  welcomeScreen: {
    title: "Bienvenue à\nl'Académie du Voyage d'Orlando", // Spécifique au produit
    helloUser: 'Bonjour {{name}}',
    hello: 'Bonjour,',
    fromAgency: 'de {{agency}}',
    notUser: 'Pas {{name}} ?',
    introOnline:
      "Formez-vous immédiatement en ligne ou préchargez le contenu pour qu'il soit toujours disponible hors ligne !",
    introOffline:
      "Vous avez déjà la dernière version préchargée. Commencez la formation ou la vente à tout moment, n'importe où !",
    startTraining: 'Commencer la formation',
    continueTraining: 'Continuer la formation',
    graduated: 'Félicitations !',
    downloader: {
      preload: 'Préchargement',
      stop: 'arrêt',
      init: 'Initialisation...',
      lastUpdate: 'Dernière mise à jour : ',
    },
  },
  trainingScreens: {
    start: 'Démarrer',
    continue: 'Continuer',
    review: 'Réviser',
    restart: 'Redémarrer',
    durationInMinutes: '{nombre} minutes',
    percentageComplete: '{nombre}% Complet',
    unlock:
      'Débloquez ce chapitre en complétant le chapitre de formation {nombre}.',
    unlockSubtitle:
      'Débloquez plus de chapitres en complétant les chapitres de formation.',
    allUnlocked: 'Vous avez débloqué tous les chapitres !',
    certificate: 'Certificat',
    courseComplete: 'Continuer',
    endReached: 'Vous avez atteint la fin',
    retainEnd:
      "Utilisez la barre supérieure pour naviguer dans ce chapitre ou appuyez sur le bouton retour pour revenir à l'aperçu.",
    watchListenRead: 'Regardez, Écoutez & Lisez plus',
    trouble:
      'Il semble que vous ayez des difficultés, veuillez relire le contenu des pages précédentes et réessayer.',
    confirm: 'Confirmez votre réponse',
    choose: 'Veuillez choisir une réponse',
    skip: 'Retour >',
    viewAllTitle: 'Conseil de Formation',
    viewAll:
      "Pour passer à la page suivante, veuillez cliquer sur les icônes pour voir le contenu supplémentaire. Des vidéos, des cartes et d'autres informations utiles sont fournies pour améliorer votre formation et garantir que vous atteignez le statut PRO.",
    fillBlanks: 'Complétez le(s) espace(s) vide(s) :',
    next: 'Question suivante',
    retry: 'Réessayer',
    fastTrackText: {
      success:
        'Félicitations, vous avez réussi le cours Fast Track et débloqué le reste de la formation !',
      failed:
        "Malheureusement, vous n'avez pas réussi le cours Fast Track, vous pouvez reprendre votre formation pour obtenir votre diplôme !",
    },
    fastTrack: 'Devenez une Superstar du Voyage en Suisse !',
    fastTrackExplanation:
      'Il vous suffit de passer le quiz sur les pages suivantes pour avoir la chance de gagner un FAM en Suisse !<br><br><span style="font-weight: bold">Vous trouverez toutes les réponses aux questions du quiz de la manière suivante :</span><br><br>1. Le contenu que vous avez appris dans les modules Rail Europe et Suisse<br><br>2. Et sur les sites Web suivants :<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Assurez-vous de passer en revue ces ressources en détail avant de passer le quiz ! Seules les personnes ayant les meilleurs scores auront la chance d\'être invitées au FAM.</span>',
    fastTrackButton: 'Cliquez ici pour passer le Quiz de la Superstar Suisse',
    grading: 'Votre note finale est : {grade}%',
  },
  nav: {
    home: 'Accueil',
    train: 'Apprendre',
    learn: 'Apprendre',
    retain: 'Consolider',
    directory: 'Annuaire',
    showRoom: 'Présentations',
    showcases: 'Présentations',
    offers: 'Offres',
    promote: 'Promouvoir',
    sell: 'Vendre',
    info: 'Infos',
    rewards: 'Récompenses',
    media: 'Médias',
    favorites: 'Favoris',
    contact: 'Contact',
    reportCard: 'Voir le Diplôme',
    accountSettings: 'Paramètres du Compte',
    messages: 'Messages',
    search: 'Rechercher',
  },
  contentHeaders: {
    specializations: 'Spécialisations',
    train: 'Apprendre',
    retain: 'Consolider',
    subapps: "Modules Partenaires d'Orlando",
    maintrainings: 'Les Fondamentaux',
    subtrainings: "L'Expérience",
  },
  pageDescriptions: {
    specializations:
      "Élevez votre statut d'Expert Orlando en complétant ces chapitres pour obtenir des badges de spécialisation",
    train: 'Éduquez, engagez-vous et devenez un expert.',
    showroom: '',
    retain:
      "Félicitations pour avoir terminé votre formation ! Vous avez maintenant accès à votre ressource de référence pour consolider vos connaissances d'expert et soutenir vos efforts de vente. Utilisez cette zone pour répondre de manière experte à une question sur le produit ou même pour effectuer une présentation de vente improvisée, à tout moment, n'importe où et depuis n'importe quel appareil.",
    promote:
      "Partagez ces éléments pour susciter l'intérêt et engager une conversation avec des clients et des prospects.",
    sell: 'Répondez aux questions des clients et concluez la vente comme un professionnel avec des ressources approfondies et un support de vente ciblé.',
    favorites: 'Consultez votre contenu favori personnel',
    search: 'Recherchez tout le contenu',
    subapps: '',
    maintrainings:
      'Commencez par les bases sur Orlando et où vos clients peuvent séjourner.',
    subtrainings:
      "Terminez ces modules sur toutes les choses incroyables que les clients peuvent faire et voir à Orlando et recevez votre certificat en tant qu'Expert Orlando officiel.",
  },
  general: {
    offerBig:
      "Avec votre statut d'expert viennent de nombreux avantages, à commencer par des offres exclusives et des réductions disponibles uniquement pour vous ! Cliquez sur le bouton Offres sur la page d'accueil pour commencer à récolter les fruits de vos efforts.",
    badge: 'Voir le Badge',
    offerMessage: 'Offre de Billet Gratuit LEGOLAND Florida',
    next: 'Suivant',
    yes: 'Oui',
    no: 'Non',
    previous: 'Précédent',
    submit: 'Soumettre',
    back: 'Retour',
    close: 'Fermer',
    page: 'Page',
    search: 'Recherche',
    logIn: 'Connexion',
    logOut: 'Déconnexion',
    viewItem: 'Voir {type}',
    imageNotFound: 'Image non trouvée',
    noResultsFor: "Aucun résultat n'a été trouvé pour : {{query}}",
    noFavorites: "Vous n'avez pas encore de favoris.",
    noMessages: "Vous n'avez encore reçu aucun message !",
    resultsFor: 'Résultats pour : {{query}}',
    showAll: 'Tout afficher',
    connectionError: 'Erreur de Connexion',
    alreadyExists: 'Existe déjà',
    pageNotFound: '404 Page Non Trouvée !',
    oops: 'Oups...',
    overview: "Retour à l'aperçu",
    complete: 'Continuer',
    courseComplete: 'Chapitre Terminé !',
    chapterComplete: 'Chapitre Terminé !',
    message: '{count} Message',
    messagePlural: '{count} Messages',
    unlock: 'Débloquez cet élément en complétant la section Apprendre.',
    completion: 'Terminez la Fondation pour débloquer cet objet',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Mise en Page',
    web: 'Site Web',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Tournez les cadrans pour correspondre à la réponse',
    fitb: 'Remplissez le(s) espace(s) vide(s)',
    flip: 'Changez le numéro pour correspondre à la réponse',
    multipleChoice: 'Choisissez la ou les bonnes réponses',
    slider: 'Choisissez la bonne réponse en utilisant le curseur',
    map: 'Répondez à la question en tapant sur le bon emplacement sur la carte',
    dropdown: 'Choisissez...',
    true: 'Vrai',
    false: 'Faux',
  },
  reportCard: {
    download: 'Télécharger',
    email: 'E-mail',
    print: 'Imprimer',
  },
  cookies: {
    consent: 'ACCEPTER',
    optout: 'Refuser',
    settings: 'Paramètres de Confidentialité',
    message:
      "Vous ne nous avez rien dit sur vos préférences en matière de confidentialité des données ! Ce n'est pas grave, mais nous aimerions vous offrir la meilleure expérience en utilisant le Sales Companion.",
    disabled: "Il semble que vous ayez désactivé l'utilisation des cookies.",
    use: "Le {{appName}} nécessite l'utilisation de cookies pour vous offrir la meilleure expérience.",
    details: 'À quoi servent les cookies ?',
    enable: 'Voyez comment activer vos cookies {{ici}}.',
    here: 'ici',
  },
  notLoggedIn: {
    super: "Vous n'êtes pas connecté",
    title: 'Vous devez être connecté pour voir ce contenu',
    guest: 'Invité',
  },
  demo: {
    message:
      "Ce site Web est une démonstration du produit final. Il est actuellement en développement et n'est pas un produit complet.",
    consent: 'Compris !',
  },
  share: {
    header: 'Partagez cette ressource sur vos réseaux sociaux préférés !',
    download: 'Télécharger',
  },
  sharing: {
    copyURL: 'Copier le lien',
    copied: 'Copié',
  },
  breadCrumbs: {
    page: 'Page',
  },
  contact: {
    vp: "Vice-Président des Ventes de l'Industrie du Voyage",
    na: "Directeur des Ventes de l'Industrie du Voyage, Amérique du Nord",
    emea: "Directeur des Ventes de l'Industrie du Voyage, EMEA",
    la: "Directeur des Ventes de l'Industrie du Voyage, Amérique Latine",
  },
  onMobile: {
    header:
      "Il semble que vous essayez d'accéder à l'application {appName} depuis un appareil mobile",
    body: "Pour télécharger ce programme, il vous suffit de vous rendre sur votre boutique d'applications et de rechercher {appName} ou de cliquer sur l'un des boutons ci-dessous",
    benefits: {
      header: 'Cela vous fournira :',
      1: 'Apprendre, Promouvoir & Vendre en Déplacement',
      2: 'Formation Multimédia sur Tous les Appareils',
      3: 'Certificat de Réussite',
      4: "Présentations de Vente Prêtes à l'Emploi",
      5: 'Matériel Promotionnel de Haute Qualité',
      6: 'Répertoire de Produits en Temps Réel',
      7: 'Actualités et Mises à Jour en Temps Opportun',
    },
  },
  directory: {
    attractions: 'Attractions',
    hotels: 'Hôtels',
    dining: 'Restauration',
    nightlife: 'Vie Nocturne',
    artsculturehistory: 'Arts, Culture & Histoire',
    themeparks: 'Parcs à Thème',
    sportsrecreationoutdoors: 'Sports, Loisirs & Plein Air',
    otheraccommodations: 'Autres Hébergements',
    shopping: 'Shopping',
    weddingservices: 'Services de Mariage',
    medicalservices: 'Services Médicaux',
    golf: 'Golf',
    transportationservices: 'Services de Transport',
    spas: 'Spas',
    filters: 'Filtres',
    reset: 'Réinitialiser les Filtres',
    view: 'Voir Maintenant',
    amount: 'Nombre de Résultats',
    retail: 'Commerce de Détail',
    accommodations: 'Hébergements',
    transportation: 'Transport',
    conventionservices: 'Services de Congrès',
    visitorprofessionalservices: 'Services aux Visiteurs et Professionnels',
    visitorandprofessionalservices: 'Services aux Visiteurs et Professionnels',
    studentandyouthgroupfriendly: 'Groupes Étudiants et Jeunes',
  },
  custom: {
    splitUsers: 'Je Suis Un ...',
    brandAmbassador: 'Ambassadeur de Marque',
    travelPro: 'Professionnel du Voyage',
  },
  search: {
    pages: 'Pages',
    resources: 'Ressources',
  },
};
